import HowInsertVideoAnimated from './HowInsertVideoAnimated';

export default HowInsertVideoAnimated;